// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 950 ? "mediapipe-bg-worker" : chunkId) + "." + {"249":"7b832e46","950":"27736705"}[chunkId] + ".chunk.js";
};